import { Theme } from '@mui/material';

export default {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => ({
			height: 'auto',
			width: 'auto',
			minWidth: '320px',
			[theme.breakpoints.down('xs')]: {
				width: '288px',
				minWidth: '288px',
			},
		}),
	},
};
